import { Avatar, Grid } from '@material-ui/core';
import RoomIcon from '@material-ui/icons/Room';
import Skeleton from '@material-ui/lab/Skeleton';
import { useStyles } from '@webapps/styles';
import VerifiedIcon from 'components/Icons/VerifiedIcon';
import PropTypes from 'prop-types';

import theme from './theme';

const {
  colors: { background, statusProfilColor },
} = theme;

const ProfilName = ({
  city,
  cp,
  firstName,
  image,
  isLoading,
  lastName,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  rate,
}) => {
  const {
    classes,
    css,
    global,
    theme: { spacing },
  } = useStyles(styles);

  return (
    <div className={classes.container} elevation={1}>
      <Grid className={classes.gridContainer}>
        <div>
          {isLoading ? (
            <Avatar className={classes.avatar} />
          ) : (
            // eslint-disable-next-line react/jsx-no-useless-fragment
            <>
              {image ? (
                <Avatar className={classes.avatar} src={image} />
              ) : (
                <Avatar className={classes.avatar}>
                  {firstName?.substr(0, 1) + lastName?.substr(0, 1)}
                </Avatar>
              )}
            </>
          )}
        </div>
        <div
          className={css({
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            marginLeft: spacing(2),
          })}
        >
          {isLoading ? (
            <>
              <Skeleton variant="text" />
              <Skeleton variant="text" />
            </>
          ) : (
            <>
              <div className={classes.name}>
                {firstName} {lastName}
                <div
                  className={css({
                    marginLeft: spacing(1),
                  })}
                >
                  <VerifiedIcon color={'#1DA1F2'} className={global.smallIcon} />
                </div>
                {/* <VerifiedUserIcon
                  className={css({ marginLeft: spacing(1) })}
                  color="primary"
                /> */}
              </div>
              {(cp || city) && (
                <div className={classes.address}>
                  <RoomIcon className={classes.imgAdress} fontSize="small" />
                  {cp} {city}
                </div>
              )}
            </>
          )}
        </div>
        {/* <div
          className={css({
            display: 'flex',
            flexDirection: 'column',
            marginLeft: 'auto',
          })}
        >
          {isLoading ? (
            <Skeleton variant="text" />
          ) : (
            <>
              <div className={classes.status}>
                Profil complet à{' '}
                <span
                  className={css({ fontWeight: 'medium', color: '#152652' })}
                >
                  {rate} %
                </span>
              </div>
              <div className={classes.progressBar}>
                <LinearProgress
                  classes={{
                    colorPrimary: css({ background: '#b6fbdc' }),
                    barColorPrimary: css({ background: '#40EF74' }),
                  }}
                  className={css({
                    height: 10,
                    borderRadius: 3,
                  })}
                  value={rate}
                  variant="determinate"
                />
              </div>
            </>
          )}
        </div> */}
      </Grid>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    background,
    borderRadius: 10,
    padding: spacing(2.5),
    marginTop: spacing(2.5),
    marginBottom: spacing(2.5),
    '@media (min-width: 768px)': { display: 'none' }
  },
  gridContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  profilName: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  profilStatus: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  btnVitrine: {
    marginLeft: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  avatar: {
    height: 80,
    width: 80,
  },
  name: {
    fontWeight: 600,
    color: '#152652',
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Montserrat',
    '@media only screen and (max-width:1920px)': {fontSize: '13.500px'},
    '@media only screen and (max-width:1600px)': {fontSize: '14px'},
  },
  address: {
    color: '#5D75A8',
    lineHeight: '110%',
    display: 'flex',
    alignItems: 'center',
    marginLeft: spacing(-1),
    marginTop: spacing(1),
    '@media only screen and (max-width:1920px)': {fontSize: '13.500px'},
    '@media only screen and (max-width:1600px)': {fontSize: '14px'},
  },
  status: {
    color: statusProfilColor,
    '@media only screen and (max-width:1920px)': {fontSize: '13.500px'},
    '@media only screen and (max-width:1600px)': {fontSize: '14px'},
  },
  progressBar: {
    marginTop: spacing(1),
  },
});

ProfilName.propTypes = {
  city: PropTypes.string,
  cp: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  isLoading: PropTypes.bool,
  rate: PropTypes.number,
  image: PropTypes.string,
};

export default ProfilName;
